export default __webpack_public_path__ + "static/image08-b40789d75230b0e41952c1fff2969e1a.webp";